module.exports = __webpack_public_path__ + "static/media/shinglePewterWood.8d97da20.png";